"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _AddCircle = _interopRequireDefault(require("@insided/destination/icons/AddCircle"));

var _Skeleton = require("@insided/destination/uikit/Skeleton");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var PaginationControls = function PaginationControls(_ref) {
  var type = _ref.type,
      isLoading = _ref.isLoading,
      pageURL = _ref.pageURL,
      onLoadPage = _ref.onLoadPage;
  var isPrevious = type === 'previous';
  return (0, _preact.h)("div", {
    className: isPrevious ? 'pagination-top' : 'pagination-bottom'
  }, (0, _preact.h)("div", {
    className: "pagination-icon"
  }, (0, _preact.h)(_AddCircle.default, {
    width: 16,
    height: 16
  })), (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(pageURL || '#'),
    className: (0, _classnames.default)('btn', isPrevious ? 'btn--secondary' : 'btn--primary', {
      'pagination-load-previous-btn': isPrevious,
      'pagination-load-more-btn': !isPrevious,
      'btn--disabled': isLoading || !pageURL
    }),
    onClick: /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!(!isLoading && pageURL)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return onLoadPage();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    "aria-disabled": isLoading || !pageURL
  }, isLoading ? (0, _preact.h)(_Skeleton.TextSkeleton, null) : (0, _preact.h)(_phrase.default, {
    p: isPrevious ? 'threaded_replies.show_previous_replies' : 'threaded_replies.show_more_replies'
  })));
};

var _default = PaginationControls;
exports.default = _default;